import { ngRoute } from '../../../../app/routing/ngRoute';
import { loginRedirect, supportService } from '@splunk/olly-services/lib';

export default [
    '$location',
    '$log',
    '$scope',
    'security',
    'googleAuth',
    'globalNavUpdateService',
    'currentUser',
    'SUBDOMAIN_ENABLED',
    'DOMAIN_ORGANIZATION_ID',
    'routeParameterService',
    'organizationService',
    'DOMAIN_INFO',
    'SSO_INFO',
    '$http',
    '$window',
    'API_URL',
    'ssoRedirect',
    'SUBDOMAIN_LOGIN_SEARCH_ENABLED',
    '$rootScope',
    'ssoService',
    'pathValidateService',
    'communityErrorService',
    'logService',
    'oauthBrokerContinuation',
    function (
        $location,
        $log,
        $scope,
        security,
        googleAuth,
        globalNavUpdateService,
        currentUser,
        SUBDOMAIN_ENABLED,
        DOMAIN_ORGANIZATION_ID,
        routeParameterService,
        organizationService,
        DOMAIN_INFO,
        SSO_INFO,
        $http,
        $window,
        API_URL,
        ssoRedirect,
        SUBDOMAIN_LOGIN_SEARCH_ENABLED,
        $rootScope,
        ssoService,
        pathValidateService,
        communityErrorService,
        logService,
        oauthBrokerContinuation
    ) {
        const isOAuthBrokerRoute = $location.path() === '/oauth-authorize';
        const oauthBrokerInspection = oauthBrokerContinuation.inspect();
        const missingOAuthBrokerState = isOAuthBrokerRoute && !oauthBrokerInspection.active;
        let oauthBrokerTerminalReason = oauthBrokerInspection.terminalReason;

        if (missingOAuthBrokerState) {
            oauthBrokerTerminalReason =
                oauthBrokerTerminalReason || oauthBrokerContinuation.getTerminalReason();
            if (!oauthBrokerTerminalReason) {
                oauthBrokerContinuation.setTerminal('invalid_request');
                oauthBrokerTerminalReason =
                    oauthBrokerContinuation.getTerminalReason() || 'storage_unavailable';
            }
        }
        const isOAuthBrokerFlow = isOAuthBrokerRoute || oauthBrokerInspection.owned;

        if ($scope.isModal) {
            // login form is in a modal.
            // hide the modal when URL changes.
            $rootScope.$on('$locationChangeStart', function () {
                security.closeLoginDialog(false);
            });
        } else {
            // hide navbar when login form is not in a modal
            globalNavUpdateService.update({ hideAll: true });
        }
        $scope.subdomainEnabled = SUBDOMAIN_ENABLED && SUBDOMAIN_LOGIN_SEARCH_ENABLED;

        // Broker continuation state is tab-local. Do not copy its route into the
        // singleton SSO redirect cookie or the ordinary post-login redirect store.
        if (!isOAuthBrokerFlow) {
            ssoRedirect.setIfEmpty($location.url());
        }

        $scope.enabled = false;
        const isIDP = $location.path().match(/^\/idp\//);

        $scope.params = angular.copy($location.search());
        const googleCode = $scope.params.google;
        $scope.params.startUnifiedIdentity = new URLSearchParams($window.location.search).get(
            'startUnifiedIdentity'
        );

        // This is the URL from which the user initiates the login flow
        $scope.userInitiatedURL = isOAuthBrokerFlow ? null : loginRedirect.getRedirectURL();

        // This controller flow get invoked multiple times when the user is not
        // logged in because of many user shims
        // 1. Only store the first URL from which the user came from
        // 2. Don't store the known un-authenticated URLs
        if (
            !isOAuthBrokerFlow &&
            !$scope.userInitiatedURL &&
            pathValidateService.isAuthenticatedPath($location.path())
        ) {
            loginRedirect.setRedirectURLIfNotFound($location.url());
        }

        if (isIDP) {
            if (!$scope.params.issuer) {
                $log.warn('Issuer is missing from the parameters');
            }

            if (pathValidateService.isAuthenticatedPath($location.path())) {
                ssoRedirect.setIdpRequestInfo($scope.params.issuer, $location.url());
            }
        }
        $scope.requester = $scope.params.requester;

        $scope.hasGoogle = googleAuth.hasGoogle() && (!DOMAIN_INFO || DOMAIN_INFO.hasGoogleSignIn);

        $scope.initGoogleAuth = googleAuth.initGoogleAuth;

        $scope.page = 'main'; // by default is main page.
        function processPage(nosso) {
            if (nosso) {
                $scope.page = 'nosso';
            } else if (DOMAIN_INFO) {
                if (SSO_INFO.length || DOMAIN_INFO.hasGoogleSignIn) {
                    $scope.page = 'sso';
                } else {
                    $scope.page = 'nossoavailable';
                }
            } else {
                $scope.page = 'main';
            }
        }
        processPage($scope.params.nosso);

        const watcher = routeParameterService.registerRouteWatch(
            'nosso',
            function (changePath, changed) {
                processPage(changed.nosso === ($scope.page === 'sso'));
            }
        );

        $scope.$on('$destroy', function () {
            watcher();
        });

        $scope.SSO_INFO = SSO_INFO;
        $scope.oauthBrokerState = null;
        if (oauthBrokerTerminalReason) {
            $scope.oauthBrokerState = 'error';
        } else if (isOAuthBrokerFlow) {
            $scope.oauthBrokerState = 'checking-session';
        }

        function failOAuthBrokerContinuation(reason) {
            oauthBrokerContinuation.setTerminal(reason);
            $scope.enabled = false;
            $scope.oauthBrokerState = 'error';
        }

        const BROKER_FAILURE_REASONS = {
            0: 'network_error',
            400: 'invalid_transaction',
            401: 'unauthenticated',
            403: 'organization_mismatch',
            404: 'disabled',
        };

        function brokerFailureReason(response) {
            const status = response?.status ?? 0;
            return BROKER_FAILURE_REASONS[status] ?? 'unknown';
        }

        function continueOAuthBrokerAuthorization() {
            $scope.enabled = false;
            $scope.oauthBrokerState = 'continuing';

            const tx = oauthBrokerContinuation.beginOnce();
            if (!tx) {
                // Another controller instance may already own the in-flight POST.
                // beginOnce also fails closed for invalid state, so never retry here.
                if (oauthBrokerContinuation.getTerminalReason()) {
                    $scope.oauthBrokerState = 'error';
                }
                return;
            }

            $http.post(API_URL + '/v2/oauth2/broker/authorize/continue', { tx }).then(
                (response) => {
                    const redirectUrl = response?.data?.redirectUrl;
                    if (typeof redirectUrl !== 'string' || !redirectUrl.trim()) {
                        failOAuthBrokerContinuation('malformed_response');
                        return;
                    }

                    oauthBrokerContinuation.clear();
                    $window.location.href = redirectUrl;
                },
                (response) => failOAuthBrokerContinuation(brokerFailureReason(response))
            );
        }

        if (!oauthBrokerTerminalReason && !(isOAuthBrokerFlow && googleCode)) {
            // try to get user id and see if it works
            currentUser
                .id()
                .then(() => {
                    if (isOAuthBrokerFlow) {
                        continueOAuthBrokerAuthorization();
                    } else if (isIDPFlow()) {
                        loginAndReturnAssertion();
                    } else if ($location.path().match(/sign/)) {
                        // if we are redirecting to home, we want to remove any query params that will only cause
                        // confusion and worst case, wrong url
                        $location.url('/home');
                    } else {
                        logService.logData(
                            'INFO',
                            'Login Controller.js -> currentUser Service Id: reload when url doesnt match from currentUser.id()',
                            url
                        );
                        ngRoute.reload();
                    }
                })
                .catch(() => {
                    // it doesn't work, let's show signin page
                    const currentTerminalReason = isOAuthBrokerFlow
                        ? oauthBrokerContinuation.getTerminalReason()
                        : null;
                    $scope.enabled = !currentTerminalReason;
                    if (currentTerminalReason) {
                        $scope.oauthBrokerState = 'error';
                    } else if (isOAuthBrokerFlow) {
                        $scope.oauthBrokerState = 'login';
                    }
                    supportService.removeSupportOrg();
                    if ($scope.params.startUnifiedIdentity) {
                        const oidcProviders = SSO_INFO.filter((p) => p.type === 'oidc');
                        if (oidcProviders.length === 1) {
                            $scope.enabled = false;
                            $scope.ssoLogin(oidcProviders[0].id, oidcProviders[0].type);
                        }
                    }
                });
        }
        $scope.user = {};
        $scope.authError = null;
        $scope.message = '';
        $scope.processingSignIn = false;

        function loginAndReturnAssertion() {
            const idpInfo = ssoRedirect.getIdpInfoAndClear();
            const issuer = $scope.params.issuer || idpInfo.issuer;
            const relayState = $scope.params.relaystate || null;
            organizationService.get().then((org) => {
                if (org.accountType === 'TRIAL') {
                    //open modal and redirect to home
                    communityErrorService.openModal();
                    $location.search('issuer', null).replace();
                    $location.path('/home');
                } else {
                    ssoService.getAssertionAndRedirect(issuer, relayState).catch(() => {
                        //Error was thrown so alert and show signin page again
                        $scope.enabled = true;
                        $location.search('issuer', null).replace();
                        $window.alert('Something went wrong');
                    });
                }
            });
        }

        $scope.redirectToSignup = function () {
            $location.path('/signup');
            if (angular.isDefined($scope.$parent.$parent.$dismiss)) {
                $scope.$parent.$parent.$dismiss();
            }
        };

        $scope.getRedirect = function () {
            if (isOAuthBrokerFlow) {
                return oauthBrokerContinuation.getResumePath();
            } else if (isIDPFlow()) {
                return null;
            } else {
                if ($location.path().match(/signin|signup/)) {
                    return loginRedirect.getRedirectURL() || '/home';
                } else {
                    logService.logData(
                        'INFO',
                        'LoginController.js -> getRedirect -> getting redirection url',
                        $location.path()
                    );
                    return $location.path();
                }
            }
        };

        $scope.login = function () {
            $scope.authError = null;
            $scope.googleAuthError = null;
            const redirect = $scope.getRedirect();
            if (isOAuthBrokerFlow && !redirect) {
                failOAuthBrokerContinuation(
                    oauthBrokerContinuation.getTerminalReason() || 'invalid_transaction'
                );
                return;
            }
            $scope.message = 'Signing in ...';
            $scope.processingSignIn = true;
            security
                .login($scope.user.email, $scope.user.password, DOMAIN_ORGANIZATION_ID, redirect, {
                    preserveRedirectState: isOAuthBrokerFlow,
                })
                .then(
                    function (status) {
                        $scope.message = '';
                        if (status.success) {
                            $scope.hideLoginForm = true;
                        }
                        if (!status.success) {
                            $scope.processingSignIn = false;
                            $scope.authError = 'Sign-in failed.';
                            if (!isOAuthBrokerFlow && status.data?.message) {
                                $scope.authError += ' ' + status.data.message;
                            }
                        } else if (!isOAuthBrokerFlow && isIDPFlow()) {
                            currentUser
                                .id()
                                .then(loginAndReturnAssertion)
                                .catch(() => {
                                    $location.path('/');
                                });
                        }
                    },
                    function (x) {
                        $scope.processingSignIn = false;
                        if (isOAuthBrokerFlow) {
                            failOAuthBrokerContinuation('unknown');
                            $scope.authError =
                                'An error occurred while signing in. Please try again.';
                        } else {
                            $scope.authError =
                                'An error occurred: ' +
                                (x && x.data && x.data.message ? x.data.message : x);
                        }
                    }
                );
        };

        $scope.ssoLogin = function (id, type) {
            $scope.ssoState = 'loading';
            if (type === 'saml') {
                const request = { providerId: id };
                if (isOAuthBrokerFlow) {
                    const tx = oauthBrokerContinuation.getTx();
                    if (!tx) {
                        failOAuthBrokerContinuation('invalid_transaction');
                        return;
                    }
                    request.tx = tx;
                }

                $http.post(API_URL + '/v2/saml/auth', request).then(
                    (response) => {
                        const redirectUrl = response?.data?.redirectUrl;
                        if (typeof redirectUrl !== 'string' || !redirectUrl.trim()) {
                            if (isOAuthBrokerFlow) {
                                failOAuthBrokerContinuation('malformed_response');
                            } else {
                                $scope.ssoState = 'error';
                            }
                            return;
                        }
                        logService.logData(
                            'INFO',
                            'LoginController.js -> ssoLogin -> received SAML redirect'
                        );
                        $window.location.href = redirectUrl;
                    },
                    (response) => {
                        if (isOAuthBrokerFlow) {
                            failOAuthBrokerContinuation(brokerFailureReason(response));
                        } else {
                            $scope.ssoState = 'error';
                        }
                    }
                );
            } else if (type === 'oidc') {
                const url = `${API_URL}/v2/session/oidc/init?integrationId=${id}&orgId=${DOMAIN_ORGANIZATION_ID}`;
                const c3EnabledParam = new URLSearchParams($window.location.search).get(
                    'c3Enabled'
                );

                $http.get(url).then(
                    (response) => {
                        if (c3EnabledParam !== null) {
                            try {
                                $window.sessionStorage.setItem(
                                    'c3Brand',
                                    JSON.stringify({
                                        orgId: DOMAIN_ORGANIZATION_ID,
                                        enabled: c3EnabledParam === 'true',
                                    })
                                );
                            } catch (_) {}
                        }
                        $window.location.href = response.data.redirectUrl;
                    },
                    () => {
                        $scope.enabled = true;
                        $scope.ssoState = 'error';
                    }
                );
            }
        };

        $scope.noSSO = function () {
            if ($scope.isModal) {
                $location.url('/signin?nosso=1');
            } else {
                $location.search({ nosso: 1 });
            }
        };

        $scope.googleAuthError = null;

        if (googleCode && !oauthBrokerTerminalReason) {
            $location.search({ google: null });
            $scope.googleAuthError = null;
            $scope.processingGoogleSignIn = true;
            security
                .googleExchange(googleCode, DOMAIN_ORGANIZATION_ID, $scope.getRedirect(), {
                    preserveRedirectState: isOAuthBrokerFlow,
                })
                .then(
                    function (result) {
                        if (!result.success) {
                            $scope.processingGoogleSignIn = false;
                            $scope.authError = null;
                            $scope.googleAuthError = 'Sign-in failed.';
                            if (isOAuthBrokerFlow) {
                                $scope.enabled = true;
                                $scope.oauthBrokerState = 'login';
                            }
                            if (!isOAuthBrokerFlow && result.data && result.data.message) {
                                $scope.googleAuthError += ' ' + result.data.message;
                            }
                            // sign the user out of google because we cannot log him/her in.
                        } else if (!isOAuthBrokerFlow && isIDPFlow()) {
                            currentUser
                                .id()
                                .then(loginAndReturnAssertion)
                                .catch(() => {
                                    $location.path('/');
                                });
                        }
                    },
                    function () {
                        $scope.processingGoogleSignIn = false;
                        if (isOAuthBrokerFlow) {
                            failOAuthBrokerContinuation('unknown');
                        } else {
                            $scope.enabled = true;
                            $scope.googleAuthError = 'Sign-in failed.';
                        }
                    }
                );
        }

        function isIDPFlow() {
            return isIDP || ssoRedirect.isIdpFlow();
        }
    },
];
